import React, { useContext, useCallback, useMemo } from "react";
import _ from "lodash";
import { WizardPage, wizardProps } from "@xengage/gw-portals-wizard-react";
import { ViewModelForm, withViewModelService } from "@xengage/gw-portals-viewmodel-react";
import { useValidation } from "@xengage/gw-portals-validation-react";
import { readViewModelValue } from "@xengage/gw-jutro-adapters-react";
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { PremierConstants } from "premier-constant-service";
import { useUpdateSubmissionServices, validationUtil } from "premier-capability-hooks";
import metadata from "./DriverDetailsPage.metadata.json5";
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import DriverDetailsComponent from "../../../components/PersonalUmbrella/Drivers/DriverDetailsComponent";
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function DriverDetailsPage(props) {
  const {
    wizardData: submissionVM,
    updateWizardData,
    viewModelService
  } = props;
  const breakpoint = useContext(BreakpointTrackerContext);
  const { onValidate, initialValidation } = useValidation(
    "DriverDetailsPage"
  );
  const { updateSubmission } = useUpdateSubmissionServices();
  const { lineName } = PremierConstants;

  const onNext = useCallback(async () => {
    const productCode = _.get(submissionVM.value, "baseData.productCode");
    // eslint-disable-next-line security/detect-object-injection
    const lobLineName = productCode ? lineName[productCode] : "";
    const response = await updateSubmission(
      lobLineName,
      "DriverDetailsPage",
      submissionVM
    );

    submissionVM.value = response;

    return submissionVM;
  }, [lineName, submissionVM, updateSubmission]);

  const driversOverrides = useMemo(() => {
    const propertyArray = _.get(submissionVM, 'lobData.perLine.coverables.perUmbLiaCoverable.driverDetails', []);
    let overrides = [];

    if (!_.isEmpty(propertyArray)) {
      overrides = propertyArray?.children.map((property, index) => ({
        [`driverDetailsComponent${index}`]: {
          overrideProps: {
            "@field": {
              // apply to all fields
              showRequired: true,
              labelPosition: "left",
            },
          },
          submissionVM,
          updateWizardData,
          pathUpdated: `lobData.perLine.coverables.perUmbLiaCoverable.driverDetails.children[${index}]`,
          propertyVM: property,
          index,
          viewModelService
        }
      }));
    }

    return Object.assign({}, ...overrides);
  }, [submissionVM, updateWizardData, viewModelService]);

  const addDriverDetails = useCallback(async () => {

    const driverObj = {
      tempID: EntityUtil.nextId(),      
    };

    const { _xCenter, _dtoName } = submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.driverDetails;

    const driverVM = viewModelService.create(driverObj, _xCenter, _dtoName);

    _.set(driverVM, 'isValidationReq.value', true);
    _.set(driverVM, 'yeaLictoopemotvehFie.value', 0);
    _.set(driverVM, 'faulAccPas3YYeaFie.value', 0);
    _.set(driverVM, 'conPas3Yea.value', 0);
    _.set(driverVM, 'automobileFie.value', true);

    submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.driverDetails.value = submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.driverDetails.value || []

    submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.driverDetails.pushElement(
      driverVM
    );
    updateWizardData(submissionVM);
  },
    [submissionVM, viewModelService, updateWizardData]
  );

  const onSave = useCallback(
    async () => {
      const subVMCopy = _.clone(submissionVM)
      const productCode = _.get(subVMCopy.value, 'baseData.productCode');

      validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.perLine.coverables.perUmbLiaCoverable.driverDetails.value, ' ')

      const lobLineName = productCode ? lineName[productCode] : '';
      await updateSubmission(lobLineName, 'DriverDetailsPage', subVMCopy);
                      
      return submissionVM;
    },
    [lineName, submissionVM, updateSubmission]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
    "@field": {
      showRequired: true,
      labelPosition: breakpoint === "desktop" ? "left" : "top",
    },
    ...driversOverrides,
  };

  const resolvers = {
    resolveCallbackMap: {
      onValidate,
      addDriverDetails
    },
    resolveComponentMap: {
      driverDetailsComponent: DriverDetailsComponent
    },
    resolveClassNameMap: styles
  };

  const readValue = useCallback(
    (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
    [submissionVM, overrideProps]
  );

  const isDisableNext = () => {
    return !(submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.driverDetails.length > 0 && submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.driverDetails
      .aspects.subtreeValid);
  }

  return (
    <WizardPage
      onNext={onNext}
      onSave={onSave}
      skipWhen={initialValidation}
      disableNext={isDisableNext()}
    >
      <ViewModelForm
        uiProps={metadata.pageContent}
        model={submissionVM}
        onModelChange={updateWizardData}
        overrideProps={overrideProps}
        onValidationChange={onValidate}
        resolveValue={readValue}
        callbackMap={resolvers.resolveCallbackMap}
        componentMap={resolvers.resolveComponentMap}
        classNameMap={resolvers.resolveClassNameMap}
      />
    </WizardPage>
  );

}
DriverDetailsPage.propTypes = wizardProps;
export default withViewModelService(DriverDetailsPage);

